<template>
  <b-input-group class="group-social-networks">
    <b-form-input
      class="mt-1"
      v-model="social_network_value"
      @blur="checkSocialNetwork()"
      :state="validateState('value')"
    ></b-form-input>
    <b-input-group-append class="mt-1">
      <b-form-radio
        v-for="(value, key) in social_networks"
        :key="key"
        v-model="social_network.social_network"
        :value="value"
        :class="value + '-icon'"
        class="social-button"
        button
      />
      <b-button
        v-b-tooltip.hover
        title="Remover campo rede social"
        variant="danger"
        @click="remove()"
      >
        <font-awesome-icon icon="trash" />
      </b-button>
    </b-input-group-append>
    <b-form-invalid-feedback> URL inválida </b-form-invalid-feedback>
  </b-input-group>
</template>

<script>
import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/esm/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/esm/mixins/form-state";

import { sortKeys } from "bootstrap-vue/esm/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/esm/utils/props";

import { validationMixin } from "vuelidate";
import { url } from "vuelidate/lib/validators";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: {},
  })
);

export default {
  mixins: [formControlMixin, formStateMixin, validationMixin],
  props,
  data: () => ({
    social_network: {},
  }),
  computed: {
    social_network_value: {
      set(value) {
        this.social_network.value = value;
      },
      get() {
        let value = this.social_network.value;
        return value;
      },
    },
    social_networks() {
      return ["linkedin", "facebook", "instagram"];
    },
  },
  validations: {
    social_network: {
      value: { url },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.social_network[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.social_network.$touch();
      console.log("SN", this.$v.social_network);
      return !this.$v.social_network.$anyError;
    },
    remove() {
      this.$emit("remove");
    },
    checkSocialNetwork() {
      this.social_networks.forEach((social_network) => {
        if (this.social_network_value.indexOf(social_network + ".com") > -1) {
          this.social_network.social_network = social_network;
        }
      });
    },
  },
  watch: {
    value: function (value) {
      this.social_network = value;
    },
  },
  async created() {
    this.social_network = this.value;
  },
};
</script>

<style>
</style>
